import styled from '@emotion/styled';

const CommentActionsWrapper = styled('div')({
  marginTop: -12,
  marginBottom: -12,
  marginLeft: 'auto',
  display: 'flex',
});

export default CommentActionsWrapper;
